import { render, staticRenderFns } from "./DateFormat.vue?vue&type=template&id=05c9573e"
import script from "./DateFormat.vue?vue&type=script&lang=js"
export * from "./DateFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports